import {
  type SerializedAutoLinkNode,
  type SerializedLinkNode,
} from '@payloadcms/richtext-lexical';
import { type JSXConverters } from '@payloadcms/richtext-lexical/react';

export const HeadingConverter: JSXConverters<
  SerializedAutoLinkNode | SerializedLinkNode
> = {
  heading: ({ node, nodesToJSX }) => {
    const children = nodesToJSX({
      nodes: node.children,
    });

    const Element = node.tag || 'h2';

    let className;

    switch (node.tag) {
      case 'h1':
        className = 'tds-heading-lg';
        break;
      case 'h2':
        className = 'tds-heading-md';
        break;
      case 'h3':
        className = 'tds-heading-sm';
        break;
      case 'h4':
        className = 'tds-heading-xs';
        break;
      default:
        className = 'tds-heading-xs';
    }

    return (
      <Element className={`mb-4 !font-normal ${className}`}>{children}</Element>
    );
  },
};
